import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';
import { AboutUsDescriptionElementDataType } from '@/components/sections/builder/elements/body/about-us/type';
import InputTab from '@/components/sections/builder/settings/input-tab';
import { ElementProps } from '@/components/sections/builder/types';
import { cn } from '@/lib/utils';
import { useBuilderStore } from '@/stores/builder';
import { Type } from 'lucide-react';
import { shallow } from 'zustand/shallow';

const defaultData: AboutUsDescriptionElementDataType = {
  name: 'Description',
  description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque at pretium odio. Maecenas viverra tortor consequat, pulvinar felis nec, aliquam diam. Nulla rutrum diam eros, ac dignissim quam pulvinar quis. Aliquam libero metus, posuere vitae maximus ac, suscipit eget mauris. Donec mauris augue, mollis in aliquet sit amet, bibendum vitae sapien.',
  textStyle: 'body',
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as AboutUsDescriptionElementDataType;

  return (
    <div
      className={cn(
        'font-normal leading-7 tracking-[4%] md:leading-8',
        data.textStyle === 'body' && 'text-base md:text-lg lg:text-lg',
        data.textStyle === 'subtitle' && 'text-sm md:text-base lg:text-base',
        data.textStyle === 'uppercase' && 'text-sm uppercase md:text-base lg:text-base'
      )}
      dangerouslySetInnerHTML={{ __html: data.description || '' }}
    ></div>
  );
};

export const ElementSetting = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as AboutUsDescriptionElementDataType;

  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
    }),
    shallow
  );

  return (
    <div className='flex flex-col gap-2'>
      <span className='my-4'>Text style</span>
      <InputTab
        defaultValue={data.textStyle}
        options={[
          { label: 'Body', value: 'body' },
          { label: 'Subtitle', value: 'subtitle' },
          { label: 'UPPERCASE', value: 'uppercase' },
        ]}
        onChange={(v) =>
          builder.setChildData(element.parentId as string, element.id, {
            textStyle: v,
          })
        }
      />
      <h3 className='mb-1'>Description</h3>
      <TextEditorMinimal
        value={data?.description as string}
        onChange={(val) =>
          builder.setChildData(element.parentId as string, element.id, {
            description: val,
          })
        }
        output='html'
        editorProps={{
          attributes: {
            class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
          },
        }}
        editable
      />
    </div>
  );
};

export const ElementPreviewIcon = Type;

const AboutUsDescription = {
  type: 'description',
  group: 'about_us',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default AboutUsDescription;
